import { Reference } from '@apollo/client';

/**
 * Concatenates new results onto the existing array without duplicates
 */
export const concatUniquePagination = (
  existing: Array<Reference> = [],
  incoming: Array<Reference> = []
): Array<Reference> => {
  const merged = existing.slice(0);

  const existingRefs = new Set(existing.map(({ __ref }) => __ref));

  incoming.forEach(({ __ref: incomingRef }) => {
    if (!existingRefs.has(incomingRef)) {
      merged.push({ __ref: incomingRef });
    }
  });

  return merged;
};

/**
 * Simple addition merge for numeric values
 */
export const mergeNumericValues = (existing = 0, incoming = 0): number => existing + incoming;
